import InfoCards from "@/components/common/InfoCards";
import { Box } from "@mui/system";
import { FC, useState } from "react";
import FormatListBulletedAddIcon from '@mui/icons-material/FormatListBulletedAdd';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';
import NewsManager from "../NewsManager";
import EventsManager from "./EventsManager";
import FormatsManager from "./FormsManager";
import { useAuth } from "@/hooks/useAuth";
import { UserRole } from "@/types";
import { editorContentEmailException } from "@/utils/permissions";

const ContentCards: FC = () => {
    const { userRole, authUser } = useAuth();
    const [selected, setSelected] = useState<number | null>(0)

    const cards = [
        {
            icon: <FormatListBulletedAddIcon />,
            iconColor: 'secondary.main',
            title: 'Noticias y Comunicados',
            content: "Publica anuncios, logros y novedades institucionales  con imágenes y formato profesional.",
            useIconBox: true
        },
        {
            icon: <FilterAltIcon />,
            iconColor: 'primary.dark',
            title: 'Eventos',
            content: "Crea eventos académicos, culturales y deportivos.  Gestiona fechas, horarios y ubicaciones.",
            useIconBox: true
        },
        ...(userRole === UserRole.SUPERADMIN || editorContentEmailException.includes(authUser?.email || "") ? [{
            icon: <InsertDriveFileIcon />,
            iconColor: 'primary.main',
            title: 'Formatos Institucionales',
            content: "Sube y organiza formatos institucionales para descarga  pública (solicitudes, autorizaciones, circulares).",
            useIconBox: true
        }] : [])
    ]
    const renderManager = () => {
        if (selected === 0) return <NewsManager />
        if (selected === 1) return <EventsManager />
        if (selected === 2) return <FormatsManager />
        return null
    }

    return (
        <Box>
            <Box sx={{ px: { xs: 6, md: 8, lg: 10 } }}>
                <InfoCards layout="stacked"
                    stackSpacing={{ xs: 1, sm: 2.5, md: 2 }}
                    containerMargin={{ xs: 3, sm: 4, md: 6, lg: 7 }}
                    cards={cards}
                    selectedIndex={selected ?? undefined}
                    onCardClick={(index) => setSelected(prev => prev === index ? null : index)}
                    animation={{ hover: 10, selected: 14, duration: 300 }}
                />
            </Box>
            <Box sx={{ px: { xs: 6, md: 8, lg: 10 } }}> {renderManager()}</Box>
        </Box>
    )
};

export default ContentCards;